import PropTypes from 'prop-types';
export const infoBadgePropTypes = {
  /**
   * Name of icon to display, one of badgeTrustUs or badgeAdDisclosure
   */
  iconName: PropTypes.oneOf(['badgeTrustUs', 'badgeAdDisclosure']),
  /**
   * Description is a text displayed next to icon in badge
   */
  description: PropTypes.string.isRequired,
  /**
   * Additional className (used by tooltip only!)
   */
  classname: PropTypes.string,
  /**
   * Children react node (used by tooltip only!)
   */
  children: PropTypes.node
};